import {useRef} from 'react'

export const useProgressBarRef = () => {
  const progressBarRef = useRef<HTMLDivElement>(null)

  const updateProgress = (progress: number) => {
    if (progressBarRef.current) {
      // Update the scaleX transform directly based on progress
      // Clamp the value between 0 and 1 to prevent overflow
      const scale = Math.max(0, Math.min(1, 1 - progress))
      progressBarRef.current.style.transform = `scaleX(${scale})`
    }
  }

  return {
    progressBarRef,
    updateProgress,
  }
}
